// ═══ 세금계산서 발행 목록 (홈택스 일괄발급) ═══
// TaxInvoicePage 의 '발행 목록' 탭 컨텐츠. 팝빌(admin 전용) 대신 전 업체가
// 발행 건을 쌓아 홈택스 공식 양식 xlsx 로 내려받는 임시 경로.
// v2: 매출/매입 서브탭 + 상태 필터(대기/다운로드됨/발행완료) + 소스 뱃지 + 발행완료 수동 확정.
// 설계: erp/app/docs/tax-hometax-export/plan-v2-data-ux.md §1 / §3
import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';

var STATUS_FILTERS = [
  { key: 'all', label: '\uC804\uCCB4' },
  { key: 'draft', label: '\uB300\uAE30' },
  { key: 'exported', label: '\uC5D1\uC140 \uC0DD\uC131\uB428' },
  { key: 'issued', label: '\uBC1C\uAE09\uC644\uB8CC' }
];

// 사업자번호 표시용 하이픈 — 저장은 숫자 10자리(정규화)라 표에서만 자리를 끊어준다.
// 10자리가 아니면(옛 데이터·해외 등) 손대지 않고 그대로 노출.
var fmtBizNo = function (v) {
  var s = String(v == null ? '' : v).replace(/[^0-9]/g, '');
  if (s.length !== 10) return v || '';
  return s.slice(0, 3) + '-' + s.slice(3, 5) + '-' + s.slice(5);
};

// source_car_ids 는 서버가 JSON 문자열/배열 어느 쪽으로 내려도 안전하게 처리
var parseCarIds = function (v) {
  if (Array.isArray(v)) return v;
  if (typeof v === 'string' && v) {
    try {
      var p = JSON.parse(v);
      return Array.isArray(p) ? p : [];
    } catch (e) { return []; }
  }
  return [];
};

// ── 안내 (앱 세금계산서(홈택스) 화면과 동일 구성) ──
// 제목 → 경고 → 진행 순서(번호 다이어그램). 한 줄 화살표 나열은 안 읽힌다는
// 피드백(Jin)에 따라 섹션을 나누고 단계마다 설명을 붙였다.
var GUIDE_STEPS = [
  { t: '\uBC1C\uAE09 \uC790\uB8CC \uCD94\uAC00', d: '\uAD6D\uB0B4 \uB9E4\uAC01 \uCC28\uB7C9\u00B7\uB9D0\uC18C \uC815\uC0B0\uC5D0\uC11C \uBD88\uB7EC\uC624\uAC70\uB098 \uC9C1\uC811 \uC785\uB825' },
  { t: '\uD648\uD0DD\uC2A4 \uC5D1\uC140 \uBC1B\uAE30', d: '\uC120\uD0DD\uD55C \uC790\uB8CC\uB97C \uC5D1\uC140 \uD55C \uC7A5\uC73C\uB85C \uB0B4\uB824\uBC1B\uAE30' },
  { t: '\uD648\uD0DD\uC2A4\uC5D0 \uC5C5\uB85C\uB4DC', d: '\uC804\uC790\uC138\uAE08\uACC4\uC0B0\uC11C \u2192 \uC77C\uAD04\uBC1C\uAE09 \uBA54\uB274\uC5D0 \uD30C\uC77C \uB4F1\uB85D', badge: '\uC2E4\uC81C \uBC1C\uAE09' },
  { t: '\uBC1C\uAE09\uC644\uB8CC \uD655\uC815', d: '\uBC1C\uAE09\uC744 \uB9C8\uCE5C \uC790\uB8CC\uB97C \uD788\uC2A4\uD1A0\uB9AC\uB85C \uB118\uAE30\uAE30' }
];

function GuideCard({ onHide }) {
  return (
    <div style={{ border: '1px solid #e2e8f0', borderRadius: 8, padding: 16, marginBottom: 12, background: '#fff' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
        <span style={{ fontSize: 16 }}>{'\uD83D\uDCC4'}</span>
        <strong style={{ fontSize: 14, color: '#1B3A5C' }}>{'\uD648\uD0DD\uC2A4 \uC77C\uAD04\uBC1C\uAE09 \uC548\uB0B4'}</strong>
      </div>

      <div style={{ display: 'flex', gap: 8, background: '#fffbeb', border: '1px solid #fcd34d', borderRadius: 6, padding: '10px 12px', marginBottom: 16 }}>
        <span style={{ fontSize: 14, lineHeight: 1.4 }}>{'\u26A0\uFE0F'}</span>
        <div>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#1B3A5C', marginBottom: 2 }}>{'\uC774 \uD654\uBA74\uC5D0\uC11C\uB294 \uC138\uAE08\uACC4\uC0B0\uC11C\uAC00 \uBC1C\uAE09\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.'}</div>
          <div style={{ fontSize: 12, color: '#64748b', lineHeight: 1.5 }}>{'\uD648\uD0DD\uC2A4 \uC77C\uAD04\uBC1C\uAE09\uC5D0 \uC62C\uB9B4 \uC5D1\uC140\uC744 \uB9CC\uB4DC\uB294 \uACF3\uC785\uB2C8\uB2E4. \uC2E4\uC81C \uBC1C\uAE09\uC740 \uD648\uD0DD\uC2A4\uC5D0\uC11C \uC774\uB8E8\uC5B4\uC9D1\uB2C8\uB2E4.'}</div>
        </div>
      </div>

      <div style={{ fontSize: 11, fontWeight: 700, color: '#94a3b8', letterSpacing: 0.4, marginBottom: 8 }}>{'\uC9C4\uD589 \uC21C\uC11C'}</div>
      {GUIDE_STEPS.map(function (st, i) {
        var last = i === GUIDE_STEPS.length - 1;
        return (
          <div key={i} style={{ display: 'flex', gap: 12 }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div style={{ width: 24, height: 24, borderRadius: '50%', background: '#eff6ff', color: '#2563eb', fontSize: 12, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{i + 1}</div>
              {!last && <div style={{ width: 2, flex: 1, background: '#e2e8f0', margin: '2px 0' }} />}
            </div>
            <div style={{ paddingBottom: last ? 0 : 14 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <span style={{ fontSize: 13, fontWeight: 700, color: '#1B3A5C' }}>{st.t}</span>
                {st.badge && <span style={{ fontSize: 10, fontWeight: 700, color: '#b45309', background: '#fffbeb', borderRadius: 4, padding: '2px 6px' }}>{st.badge}</span>}
              </div>
              <div style={{ fontSize: 12, color: '#64748b', marginTop: 2, lineHeight: 1.5 }}>{st.d}</div>
            </div>
          </div>
        );
      })}
      <div style={{ textAlign: 'right', marginTop: 4 }}>
        <button onClick={onHide} style={{ background: 'none', border: 'none', color: '#64748b', fontSize: 12, cursor: 'pointer', padding: '2px 4px' }}>{'\uC548\uB0B4 \uC811\uAE30'}</button>
      </div>
    </div>
  );
}

var sourceBadge = function (d) {
  var st = d.sourceType || 'manual';
  if (st === 'car_sale') return { label: '\uCC28\uB7C9 ' + parseCarIds(d.sourceCarIds).length + '\uB300', bg: '#eff6ff', fg: '#2563eb' };
  if (st === 'cancel_settlement') return { label: '\uB9D0\uC18C\uC815\uC0B0', bg: '#f5f3ff', fg: '#7c3aed' };
  return { label: '\uC9C1\uC811', bg: '#f1f5f9', fg: '#64748b' };
};

var statusBadge = function (status) {
  if (status === 'issued') return { label: '\uBC1C\uAE09\uC644\uB8CC', bg: '#dbeafe', fg: '#1d4ed8' };
  if (status === 'exported') return { label: '\uC5D1\uC140 \uC0DD\uC131\uB428', bg: '#dcfce7', fg: '#16a34a' };
  return { label: '\uB300\uAE30', bg: '#f1f5f9', fg: '#64748b' };
};

var fmtDate = function (yyyymmdd) {
  var s = String(yyyymmdd || '');
  return s.length === 8 ? s.slice(0, 4) + '-' + s.slice(4, 6) + '-' + s.slice(6, 8) : s;
};

var num = function (v) { return (parseInt(v) || 0).toLocaleString(); };

var th = { padding: '10px 8px', borderBottom: '2px solid #e2e8f0', textAlign: 'left', fontWeight: 700, color: '#475569' };

// ── 매입 요약 (읽기 전용) ──
function PurchaseSummary({ showToast }) {
  var [loading, setLoading] = useState(false);
  var [purchases, setPurchases] = useState([]);
  var [cancelFees, setCancelFees] = useState([]);

  var load = function () {
    setLoading(true);
    authFetch(API + '/tax-invoice-drafts/purchase-summary').then(function (r) { return r.json(); }).then(function (d) {
      setPurchases(d.purchases || []);
      setCancelFees(d.cancelFees || []);
      setLoading(false);
    }).catch(function () { setLoading(false); showToast('\uB9E4\uC785 \uB0B4\uC5ED \uC870\uD68C \uC2E4\uD328', 'err'); });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(function () { load(); }, []);

  var sum = function (rows, field) {
    return rows.reduce(function (s, r) { return s + (parseInt(r[field]) || 0); }, 0);
  };

  if (loading) return <div className="card" style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>{'\uB85C\uB529 \uC911...'}</div>;

  return (
    <div>
      <div className="card" style={{ padding: 16, marginBottom: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
          <h3 style={{ fontSize: 14, margin: 0, color: '#1B3A5C' }}>{'\uC0AC\uC5C5\uC790 \uB9E4\uC785 \uCC28\uB7C9 (' + purchases.length + '\uAC74)'}</h3>
          <button onClick={load} style={{ padding: '6px 16px', borderRadius: 6, border: '1px solid #d0d5dd', background: '#fff', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{'\uC0C8\uB85C\uACE0\uCE68'}</button>
        </div>
        {purchases.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 30, color: '#94a3b8', fontSize: 12 }}>{'\uC0AC\uC5C5\uC790 \uB9E4\uC785(\uACF5\uAE09\uAC00\uC561\u00B7\uC138\uC561 \uC785\uB825) \uCC28\uB7C9\uC774 \uC5C6\uC2B5\uB2C8\uB2E4'}</div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
            <thead>
              <tr style={{ background: '#f8fafc' }}>
                {['\uCC28\uB7C9\uBC88\uD638', '\uCC28\uC885', '\uB9E4\uC785\uC77C', '\uB9E4\uC785\uCC98', '\uACF5\uAE09\uAC00\uC561', '\uC138\uC561', '\uD569\uACC4'].map(function (h, i) {
                  return <th key={i} style={th}>{h}</th>;
                })}
              </tr>
            </thead>
            <tbody>
              {purchases.map(function (p, idx) {
                return (
                  <tr key={p.carId || idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                    <td style={{ padding: '8px', fontWeight: 600 }}>{p.carNo || '-'}</td>
                    <td style={{ padding: '8px' }}>{p.carType || '-'}</td>
                    <td style={{ padding: '8px' }}>{fmtDate(p.purchaseDate) || '-'}</td>
                    <td style={{ padding: '8px' }}>{p.supplierName || '-'}</td>
                    <td style={{ padding: '8px', textAlign: 'right', fontWeight: 600 }}>{num(p.supplyAmount)}</td>
                    <td style={{ padding: '8px', textAlign: 'right' }}>{num(p.vatAmount)}</td>
                    <td style={{ padding: '8px', textAlign: 'right', fontWeight: 600 }}>{num(p.totalAmount)}</td>
                  </tr>
                );
              })}
              <tr style={{ background: '#f8fafc', fontWeight: 700 }}>
                <td style={{ padding: '8px' }} colSpan={4}>{'\uD569\uACC4'}</td>
                <td style={{ padding: '8px', textAlign: 'right' }}>{sum(purchases, 'supplyAmount').toLocaleString()}</td>
                <td style={{ padding: '8px', textAlign: 'right' }}>{sum(purchases, 'vatAmount').toLocaleString()}</td>
                <td style={{ padding: '8px', textAlign: 'right' }}>{sum(purchases, 'totalAmount').toLocaleString()}</td>
              </tr>
            </tbody>
          </table>
        )}
      </div>

      <div className="card" style={{ padding: 16 }}>
        <h3 style={{ fontSize: 14, margin: '0 0 8px', color: '#1B3A5C' }}>{'\uB9D0\uC18C\uB300\uD589 \uC218\uC218\uB8CC (' + cancelFees.length + '\uAC74)'}</h3>
        {cancelFees.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 30, color: '#94a3b8', fontSize: 12 }}>{'\uC218\uCDE8\uD55C \uB9D0\uC18C\uB300\uD589 \uC218\uC218\uB8CC \uACC4\uC0B0\uC11C\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4'}</div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
            <thead>
              <tr style={{ background: '#f8fafc' }}>
                {['\uB300\uD589\uC0AC', '\uC815\uC0B0\uC6D4', '\uACF5\uAE09\uAC00\uC561', '\uC138\uC561', '\uD569\uACC4', '\uC0C1\uD0DC'].map(function (h, i) {
                  return <th key={i} style={th}>{h}</th>;
                })}
              </tr>
            </thead>
            <tbody>
              {cancelFees.map(function (f, idx) {
                return (
                  <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                    <td style={{ padding: '8px', fontWeight: 600 }}>{f.agencyName || '-'}</td>
                    <td style={{ padding: '8px' }}>{f.month || '-'}</td>
                    <td style={{ padding: '8px', textAlign: 'right', fontWeight: 600 }}>{num(f.supplyAmount)}</td>
                    <td style={{ padding: '8px', textAlign: 'right' }}>{num(f.taxAmount)}</td>
                    <td style={{ padding: '8px', textAlign: 'right', fontWeight: 600 }}>{num(f.totalAmount)}</td>
                    <td style={{ padding: '8px', fontSize: 11, color: '#64748b' }}>{f.status || '-'}</td>
                  </tr>
                );
              })}
              <tr style={{ background: '#f8fafc', fontWeight: 700 }}>
                <td style={{ padding: '8px' }} colSpan={2}>{'\uD569\uACC4'}</td>
                <td style={{ padding: '8px', textAlign: 'right' }}>{sum(cancelFees, 'supplyAmount').toLocaleString()}</td>
                <td style={{ padding: '8px', textAlign: 'right' }}>{sum(cancelFees, 'taxAmount').toLocaleString()}</td>
                <td style={{ padding: '8px', textAlign: 'right' }}>{sum(cancelFees, 'totalAmount').toLocaleString()}</td>
                <td style={{ padding: '8px' }}></td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

// ── 매출 (발행 목록) ──
function SalesDrafts({ showToast, onEdit }) {
  var [drafts, setDrafts] = useState([]);
  var [loading, setLoading] = useState(false);
  var [selected, setSelected] = useState([]);
  var [downloading, setDownloading] = useState(false);
  var [marking, setMarking] = useState(false);
  // 기본은 접힘 (Jin 지시) — 목록이 화면을 다 쓰고, 필요할 때 제목 옆 ! 로 펼친다.
  // 사용자가 명시적으로 펼친 경우('0')만 열어둔 채 유지.
  var [guideHidden, setGuideHidden] = useState(function () { return localStorage.getItem('tax_drafts_guide_collapsed') !== '0'; });

  var [statusFilter, setStatusFilter] = useState('all');

  var load = function () {
    setLoading(true);
    authFetch(API + '/tax-invoice-drafts').then(function (r) { return r.json(); }).then(function (d) {
      setDrafts(d.drafts || []);
      setSelected([]);
      setLoading(false);
    }).catch(function () { setLoading(false); });
  };

  useEffect(function () { load(); }, []);

  var visible = drafts.filter(function (d) {
    if (statusFilter === 'all') return true;
    var st = d.status || 'draft';
    return st === statusFilter;
  });
  // 발행완료(issued)는 히스토리 — 선택 불가
  var selectable = visible.filter(function (d) { return (d.status || 'draft') !== 'issued'; });

  var toggle = function (id) {
    setSelected(function (prev) {
      return prev.indexOf(id) >= 0 ? prev.filter(function (x) { return x !== id; }) : prev.concat(id);
    });
  };

  var toggleAll = function () {
    setSelected(function (prev) {
      return prev.length === selectable.length ? [] : selectable.map(function (d) { return d.id; });
    });
  };

  var changeFilter = function (key) { setStatusFilter(key); setSelected([]); };

  // 선택 전부 exported 일 때만 '발행 완료 처리' 활성
  var selectedDrafts = drafts.filter(function (d) { return selected.indexOf(d.id) >= 0; });
  var canMarkIssued = selectedDrafts.length > 0 && selectedDrafts.every(function (d) { return d.status === 'exported'; });

  var handleDelete = function (id) {
    if (!window.confirm('\uC774 \uC790\uB8CC\uB97C \uC0AD\uC81C\uD560\uAE4C\uC694?')) return;
    authFetch(API + '/tax-invoice-drafts/' + id, { method: 'DELETE' }).then(function (r) { return r.json(); }).then(function (d) {
      if (d.success) { showToast('\uC0AD\uC81C \uC644\uB8CC'); load(); }
      else showToast(d.error || '\uC0AD\uC81C \uC2E4\uD328', 'err');
    }).catch(function () { showToast('\uC0AD\uC81C \uC2E4\uD328', 'err'); });
  };

  var handleMarkIssued = function () {
    if (!canMarkIssued) { showToast('\uC5D1\uC140 \uC0DD\uC131\uB428 \uC0C1\uD0DC\uC758 \uC790\uB8CC\uB9CC \uBC1C\uAE09\uC644\uB8CC\uB85C \uD655\uC815\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4', 'err'); return; }
    setMarking(true);
    authFetch(API + '/tax-invoice-drafts/mark-issued', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ids: selected })
    }).then(function (r) { return r.json(); }).then(function (d) {
      setMarking(false);
      if (d.success) { showToast('\u2705 ' + (d.updated || 0) + '\uAC74 \uBC1C\uAE09\uC644\uB8CC \uD655\uC815'); load(); }
      else showToast(d.error || '\uBC1C\uAE09\uC644\uB8CC \uD655\uC815 \uC2E4\uD328', 'err');
    }).catch(function () { setMarking(false); showToast('\uBC1C\uAE09\uC644\uB8CC \uD655\uC815 \uC2E4\uD328', 'err'); });
  };

  var handleDownload = function () {
    if (selected.length === 0) { showToast('\uC5D1\uC140\uB85C \uBC1B\uC744 \uC790\uB8CC\uB97C \uC120\uD0DD\uD574\uC8FC\uC138\uC694', 'err'); return; }
    setDownloading(true);
    authFetch(API + '/tax-invoice-drafts/export', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ids: selected })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (d) { throw new Error(d.error || '\uB2E4\uC6B4\uB85C\uB4DC \uC2E4\uD328'); });
      return r.blob();
    }).then(function (blob) {
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = '\uD648\uD0DD\uC2A4\uC77C\uAD04\uBC1C\uAE09_' + selected.length + '\uAC74.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      // 다운로드 성공 → exported 마킹 (재발행 방지 참고용)
      return authFetch(API + '/tax-invoice-drafts/mark-exported', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ids: selected })
      });
    }).then(function () {
      setDownloading(false);
      showToast('\u2705 \uC5D1\uC140 \uC0DD\uC131 \uC644\uB8CC \u2014 \uD648\uD0DD\uC2A4\uC5D0 \uC5C5\uB85C\uB4DC\uD558\uBA74 \uBC1C\uAE09\uB429\uB2C8\uB2E4');
      load();
    }).catch(function (e) {
      setDownloading(false);
      showToast(e.message || '\uB2E4\uC6B4\uB85C\uB4DC \uC2E4\uD328', 'err');
    });
  };

  var toggleGuide = function () {
    setGuideHidden(function (prev) {
      var next = !prev;
      localStorage.setItem('tax_drafts_guide_collapsed', next ? '1' : '0');
      return next;
    });
  };

  return (
    <div className="card" style={{ padding: 16 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <h3 style={{ fontSize: 14, margin: 0, color: '#1B3A5C' }}>{'\uD648\uD0DD\uC2A4 \uBC1C\uAE09 \uC790\uB8CC'}</h3>
          <button onClick={toggleGuide} title={guideHidden ? '\uC548\uB0B4 \uBCF4\uAE30' : '\uC548\uB0B4 \uC811\uAE30'}
            style={{ width: 22, height: 22, lineHeight: '20px', borderRadius: '50%', border: '1px solid #fcd34d', background: '#fffbeb', color: '#b45309', fontSize: 13, fontWeight: 700, cursor: 'pointer', padding: 0 }}>{'!'}</button>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={load} style={{ padding: '6px 16px', borderRadius: 6, border: '1px solid #d0d5dd', background: '#fff', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{'\uC0C8\uB85C\uACE0\uCE68'}</button>
          <button onClick={handleMarkIssued} disabled={marking || !canMarkIssued} style={{ padding: '6px 16px', borderRadius: 6, border: 'none', background: marking || !canMarkIssued ? '#94a3b8' : '#1d4ed8', color: '#fff', fontSize: 12, fontWeight: 700, cursor: marking || !canMarkIssued ? 'default' : 'pointer' }}>
            {marking ? '\uCC98\uB9AC \uC911...' : '\uBC1C\uAE09\uC644\uB8CC \uD655\uC815 (' + selected.length + '\uAC74)'}
          </button>
          <button onClick={handleDownload} disabled={downloading || selected.length === 0} style={{ padding: '6px 16px', borderRadius: 6, border: 'none', background: downloading || selected.length === 0 ? '#94a3b8' : '#2563eb', color: '#fff', fontSize: 12, fontWeight: 700, cursor: downloading || selected.length === 0 ? 'default' : 'pointer' }}>
            {downloading ? '\uC0DD\uC131 \uC911...' : '\uD648\uD0DD\uC2A4 \uC5D1\uC140 \uBC1B\uAE30 (' + selected.length + '\uAC74)'}
          </button>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 6, marginBottom: 10 }}>
        {STATUS_FILTERS.map(function (f) {
          var on = statusFilter === f.key;
          return (
            <button key={f.key} onClick={function () { changeFilter(f.key); }} style={{ padding: '5px 14px', borderRadius: 999, border: on ? '1px solid #0891b2' : '1px solid #d0d5dd', background: on ? '#ecfeff' : '#fff', color: on ? '#0891b2' : '#64748b', fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>
              {f.label}
            </button>
          );
        })}
      </div>

      {!guideHidden && <GuideCard onHide={toggleGuide} />}

      {loading ? (
        <div style={{ textAlign: 'center', padding: 40, color: '#94a3b8' }}>{'\uB85C\uB529 \uC911...'}</div>
      ) : visible.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 40, color: '#94a3b8' }}>{'\uD574\uB2F9 \uC870\uAC74\uC758 \uC790\uB8CC\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4. \uBC1C\uD589 \uD0ED\uC5D0\uC11C "\uBC1C\uAE09 \uC790\uB8CC\uC5D0 \uCD94\uAC00"\uB85C \uB9CC\uB4E4\uC5B4\uC8FC\uC138\uC694.'}</div>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
          <thead>
            <tr style={{ background: '#f8fafc' }}>
              <th style={Object.assign({}, th, { width: 32 })}>
                <input type="checkbox" checked={selectable.length > 0 && selected.length === selectable.length} onChange={toggleAll} disabled={selectable.length === 0} />
              </th>
              {['\uC791\uC131\uC77C\uC790', '\uACF5\uAE09\uBC1B\uB294\uC790', '\uC0AC\uC5C5\uC790\uBC88\uD638', '\uACF5\uAE09\uAC00\uC561', '\uC138\uC561', '\uC18C\uC2A4', '\uAD6C\uBD84', '\uC0C1\uD0DC', ''].map(function (h, i) {
                return <th key={i} style={th}>{h}</th>;
              })}
            </tr>
          </thead>
          <tbody>
            {visible.map(function (d) {
              var st = d.status || 'draft';
              var issued = st === 'issued';
              var sb = statusBadge(st);
              var src = sourceBadge(d);
              return (
                <tr key={d.id} style={{ borderBottom: '1px solid #f1f5f9', background: issued ? '#fafafa' : '#fff' }}>
                  <td style={{ padding: '8px', textAlign: 'center' }}>
                    <input type="checkbox" checked={selected.indexOf(d.id) >= 0} disabled={issued} onChange={function () { toggle(d.id); }} />
                  </td>
                  <td style={{ padding: '8px' }}>{fmtDate(d.writeDate)}</td>
                  <td style={{ padding: '8px', fontWeight: 600 }}>{d.invoiceeCorpName || '-'}</td>
                  <td style={{ padding: '8px', fontFamily: 'monospace', fontSize: 11 }}>{fmtBizNo(d.invoiceeCorpNum) || '-'}</td>
                  <td style={{ padding: '8px', textAlign: 'right', fontWeight: 600 }}>{num(d.supplyCostTotal)}</td>
                  <td style={{ padding: '8px', textAlign: 'right' }}>{num(d.taxTotal)}</td>
                  <td style={{ padding: '8px' }}>
                    <span style={{ padding: '2px 8px', borderRadius: 4, fontSize: 10, fontWeight: 700, background: src.bg, color: src.fg }}>{src.label}</span>
                  </td>
                  <td style={{ padding: '8px', fontSize: 11 }}>{(d.taxType || '') + '/' + (d.purposeType || '')}</td>
                  <td style={{ padding: '8px' }}>
                    <span style={{ padding: '2px 8px', borderRadius: 4, fontSize: 10, fontWeight: 700, background: sb.bg, color: sb.fg }}>{sb.label}</span>
                  </td>
                  <td style={{ padding: '8px', whiteSpace: 'nowrap' }}>
                    <button onClick={function () { onEdit(d); }} style={{ padding: '4px 10px', borderRadius: 4, border: '1px solid #2563eb', background: '#fff', color: '#2563eb', fontSize: 10, fontWeight: 600, cursor: 'pointer', marginRight: 4 }}>{'\uC218\uC815'}</button>
                    <button onClick={function () { handleDelete(d.id); }} style={{ padding: '4px 10px', borderRadius: 4, border: '1px solid #ef4444', background: '#fff', color: '#ef4444', fontSize: 10, fontWeight: 600, cursor: 'pointer' }}>{'\uC0AD\uC81C'}</button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}

function TaxInvoiceDrafts({ showToast, onEdit, user }) {
  var [subTab, setSubTab] = useState('sales');
  // 대행사는 매출(말소 수수료 발행)만 — 매입(차량 매입/수수료 수취)은 수출업체 소관
  var isCancelAgency = user && user.role === 'cancel_agency';

  var tabStyle = function (key, color, bg) {
    var on = subTab === key;
    return { padding: '8px 22px', borderRadius: 8, border: on ? '2px solid ' + color : '1px solid #d0d5dd', background: on ? bg : '#fff', color: on ? color : '#475569', fontWeight: 700, fontSize: 13, cursor: 'pointer' };
  };

  if (isCancelAgency) return <SalesDrafts showToast={showToast} onEdit={onEdit} />;

  return (
    <div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
        <button onClick={function () { setSubTab('sales'); }} style={tabStyle('sales', '#0891b2', '#ecfeff')}>{'\uB9E4\uCD9C'}</button>
        <button onClick={function () { setSubTab('purchase'); }} style={tabStyle('purchase', '#16a34a', '#f0fdf4')}>{'\uB9E4\uC785'}</button>
      </div>
      {subTab === 'sales'
        ? <SalesDrafts showToast={showToast} onEdit={onEdit} />
        : <PurchaseSummary showToast={showToast} />}
    </div>
  );
}

export default TaxInvoiceDrafts;
